var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "GiftList",
      "extra-items": _vm.readonly ? [{
        text: _vm.gift.name
      }] : _vm.isEdit ? [{
        text: _vm.gift.name,
        to: 'GiftDetail',
        params: _vm.$route.params.gift_id
      }, '編輯贈品'] : ['新增贈品']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.readonly ? "贈品明細" : _vm.isEdit ? "編輯贈品" : "新增贈品"))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "贈品名稱*"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.gift.name,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "name", $$v);
      },
      expression: "gift.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.gift.name.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "活動ID"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.gift.event_id,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "event_id", $$v);
      },
      expression: "gift.event_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "所需點數"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.gift.point_need,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "point_need", $$v);
      },
      expression: "gift.point_need"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "贈品剩餘數量*"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.gift.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "quantity", $$v);
      },
      expression: "gift.quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.gift.quantity.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "贈品初始數量*"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.gift.original_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "original_quantity", $$v);
      },
      expression: "gift.original_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.gift.original_quantity.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "類別"
    }
  }, [_c('b-select', {
    attrs: {
      "options": _vm.typeOptions
    },
    model: {
      value: _vm.gift.type,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "type", $$v);
      },
      expression: "gift.type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "排序"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.gift.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "sort", $$v);
      },
      expression: "gift.sort"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "補充資料"
    }
  }, [_c('b-form-textarea', {
    model: {
      value: _vm.gift.data,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "data", $$v);
      },
      expression: "gift.data"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.gift.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.gift, "is_enabled", $$v);
      },
      expression: "gift.is_enabled"
    }
  })], 1), _c('b-form-group', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("設定贈品照片")])])]), _c('img', {
    staticClass: "s-cropped-image",
    attrs: {
      "src": _vm.image
    }
  }), _c('ImageSelector', {
    on: {
      "input": function input($event) {
        return _vm.handleImagesChange($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          attrs: {
            "disabled": !_vm.canClick
          },
          on: {
            "click": openFileSelector
          }
        }, [_vm.canClick ? [_vm.image ? _c('div', [_c('div', {
          staticClass: "add-image-icon"
        }, [_vm._v("＋")]), _c('div', [_vm._v("更換圖片")])]) : _c('div', [_c('div', {
          staticClass: "add-image-icon"
        }, [_vm._v("＋")]), _c('div', [_vm._v("上傳圖片")])])] : [_vm._v(" 上傳中... ")]], 2)];
      }
    }])
  })], 1)], 1)], 1)]), !_vm.readonly ? _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [[_vm._v("返回")]], 2), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm.isEdit ? [_vm._v("確認編輯")] : _vm._e(), _vm.isCreate ? [_vm._v("確認新增")] : _vm._e()], 2)], 1) : _vm._e()])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }